<template>
    <div>
        Erreur
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="sass" scoped>

</style>